
import React, {useContext} from "react";
import '../main.mjs';
import {SearchContext} from "./SearchContext.js";

const AwardBadge = ({award, placement, small}) => {
    const {awardsData} = useContext(SearchContext);
    const a = awardsData.find(ad => ad.id == award);
    if (!a) {
        return null;
    }
    var badge = placement === 'Winner' ? '/assets/img/awardwinner.png' : '/assets/img/awardnominee.png';
    if (a.logo) {
        badge = a.logo;
    }
    var bigbadge = placement === 'Winner' ? '/assets/img/awardwinnerwordsonly.png' : '/assets/img/awardshortlistedwordsonly.png';

    return (
        <a href={"/awards-timeline/"+a.group+"/"+award+"/shortlist"} className={!small ? "compoundAwardBadge" : ""}>
            <span>
                <img className={"bookBadge award "+placement} src={badge} title={`${placement} - ${a.name} ${a.date}`} />
            </span>
            {!small && <span>
                <img className={"bookBadge award "+placement} src={bigbadge} title={`${placement} - ${a.name} ${a.date}`} />
            </span>}
        </a>
    )
}

export default AwardBadge;